import React from 'react';
import AddCircleOutlineOutlined from '@mui/icons-material/AddCircleOutlineOutlined';
import { useTranslation } from 'react-i18next';
import useCaseModal from '../../hooks/useCaseModal';
import PermissionedButton from 'components/PermissionedButton/PermissionedButton';
import { CaseForm, CaseListItem } from 'queries/cases/types';

const AddNewCaseButton: React.FC<{
  className?: string;
  data?: Partial<CaseForm | CaseListItem>;
  onClickHandler?: () => void;
}> = ({ className, data, onClickHandler }) => {
  const { t } = useTranslation();
  const { openCaseModal } = useCaseModal();
  return (
    <PermissionedButton
      className={className}
      onClick={() => {
        onClickHandler?.();
        openCaseModal(data);
      }}
      startIcon={<AddCircleOutlineOutlined />}
    >
      {t('case:new')}
    </PermissionedButton>
  );
};

export default AddNewCaseButton;
